// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__25oH5","selects":"Documents_selects__2RM0N"};